import { FC } from 'react';
import { FavoriteToggle } from '#advert/components/card';
import advertCardHeaderCss from '../../assets/advert-card-header.module.scss';

const Actions: FC = () => (
  <div className={advertCardHeaderCss.advertCardHeader__actions}>
    <FavoriteToggle />
  </div>
);

export { Actions };
